import { Space, Text, WithEllipsisTooltip } from '@procurify/ui'

import { Price } from '@webapp/core/components/Price'
import { type CurrencyName } from '@webapp/core/entities/external/Currency/CurrencyName'
import { ConversationOrderSummaryStepper } from './ConversationOrderSummaryStepper'
import { ConversationOrderSummaryThumbnail } from './ConversationOrderSummaryThumbnail'
import { type IConversationVendorOrderSummaryItem } from './ConversationVendorOrderSummary'
import { ConversationOrderSummaryNameCellStyled } from './styles/ConversationOrderSummaryNameCellStyled'
import { ConversationOrderSummaryPriceStyled } from './styles/ConversationOrderSummaryPriceStyled'

export interface IConversationVendorOrderSummaryLineProps {
  item: IConversationVendorOrderSummaryItem
  currency: CurrencyName
  disabled?: boolean
  isRemoveDisabled?: boolean
  onQuantityChange: (itemId: string, quantity: number) => void
  onRemove: (itemId: string) => void
}

export const ConversationVendorOrderSummaryLine = ({
  item,
  currency,
  disabled,
  isRemoveDisabled,
  onQuantityChange,
  onRemove,
}: IConversationVendorOrderSummaryLineProps) => (
  <>
    <ConversationOrderSummaryNameCellStyled>
      <Space direction='horizontal' align='center' size='small'>
        <ConversationOrderSummaryThumbnail img={item.img} />
        <Space.Item grow={1} minWidth={0}>
          <WithEllipsisTooltip title={item.name}>
            <Text noWrap textEllipsis className='fs-mask'>
              {item.name}
            </Text>
          </WithEllipsisTooltip>
        </Space.Item>
      </Space>
    </ConversationOrderSummaryNameCellStyled>
    <ConversationOrderSummaryStepper
      item={item}
      disabled={disabled}
      isRemoveDisabled={isRemoveDisabled}
      onQuantityChange={onQuantityChange}
      onRemove={onRemove}
    />
    <ConversationOrderSummaryPriceStyled className='fs-mask'>
      <Price inline price={item.price} currency={item.currency ?? currency} />
    </ConversationOrderSummaryPriceStyled>
  </>
)
